<div class="row">
  <div class="col-md-3">
    <app-ng-material-single-form
      [label]="'Created By'"
      [formField]="'label'"
      [value]="getData(data.createdByName, data.creationTime)"
    ></app-ng-material-single-form>
  </div>
  <div class="col-md-3">
    <app-ng-material-single-form
      [label]="'Updated By'"
      [formField]="'label'"
      [value]="getData(data.updatedByName, data.updateTime)"
    ></app-ng-material-single-form>
  </div>
  <div class="col-md-3" *ngIf="data.confirmedBy">
    <app-ng-material-single-form
      [label]="'Confirmed By'"
      [formField]="'label'"
      [value]="getData(data.confirmedBy, data.confirmedDate)"
    ></app-ng-material-single-form>
  </div>
  <div class="col-md-3" *ngIf="data.receivedBy">
    <app-ng-material-single-form
      [label]="'Received By'"
      [formField]="'label'"
      [value]="getData(data.receivedBy, data.receivedDate)"
    ></app-ng-material-single-form>
  </div>
</div>
